module.exports = __webpack_public_path__ + "fb7264e6b66ec9fd626e787ff22bc59e.jpg";